export enum WidgetRecommendationName {
    TRENDING = 'home_trending_products',
    PDP_SIMILAR_ITEMS = 'pdp_similar_items',
    SEARCH_RECENTLY_VIEWED = 'search_recently_viewed_products',
    PDP_RECENTLY_VIEWED = 'pdp_recently_viewed_products',
    PDP_YOU_MAY_ALSO_LIKE = 'pdp_you_may_also_like',
    ATC_YOU_MAY_ALSO_LIKE = 'atc_you_may_also_like',
    CART_RECENTLY_VIEWED = 'cart_recently_viewed_products',
}
